import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';

export const routing = defineRouting({
  locales: ['cs', 'en', 'sk'],
  defaultLocale: 'cs'
});

export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);